<template>
  <div class="evaluation_page">
    <h1>主播评价</h1>
    <div class="user-options clearfix">
      <el-input
        v-model="agentNames.content"
        placeholder="代理名称"
        style="width: 150px"
      ></el-input>
      <el-input
        v-model="hostRids.content"
        placeholder="主播rid,用逗号分割"
        style="margin-left: 10px; width: 200px"
      ></el-input>
      <DatePicker @datePickedChange="datePickedChange"></DatePicker>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
      <el-button type="primary" @click="downloadAllHost"
        >下载所有主播</el-button
      >
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomTable
          :tableList="tableList"
          :options="tableOptions"
          class="table"
        ></CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from '../../components/CustomTable'
import DatePicker from '../../components/DatePicker'

export default {
  components: {
    CustomTable,
    DatePicker
  },
  data() {
    return {
      agentNames: {
        content: ''
      },
      hostRids: {
        content: ''
      },
      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore
      ],
      tableOptions: {
        theader: [
          {
            name: 'uid',
            label: 'uid',
            sortable: true,
            fixed: true,
            width: '250px'
          },
          {
            name: 'rid',
            label: 'rid',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'name',
            label: 'name',
            sortable: true,
            fix: true,
            width: '220px'
          },
          {
            name: 'agentId',
            label: '代理id',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'agentName',
            label: '代理名称',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'callCount',
            label: '付费通话次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'count0',
            label: 'A',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count1',
            label: 'B',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count2',
            label: 'C',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count3',
            label: 'D',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count4',
            label: 'E',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count5',
            label: 'F',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count6',
            label: 'G',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count7',
            label: 'H',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count8',
            label: 'I',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count9',
            label: 'J',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count10',
            label: 'K',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count11',
            label: 'L',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count12',
            label: 'M',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count13',
            label: 'N',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count14',
            label: 'O',
            sortable: true,
            fix: true,
            width: '80px'
          },
          {
            name: 'count15',
            label: 'P',
            sortable: true,
            fix: true,
            width: '80px'
          }
        ]
      },
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.loading = false
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.reports_evaluation,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          agent_name: this.agentNames.content,
          host_list: this.hostRids.content
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
    },
    doInquery() {
      this.getList()
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_download_evaluation +
        '?token=' +
        this.token +
        '&start=' +
        this.datePicked[0] +
        '&end=' +
        this.datePicked[1] +
        '&agent_name=' +
        this.agentNames.content +
        '&host_list=' +
        this.hostRids.content +
        '&username=' +
        this.username
    },
    // 下载全部主播
    downloadAllHost() {
      window.location.href =
        this.$store.getters.path.reports_download_all_host +
        '?token=' +
        this.token +
        '&agent_name=' +
        this.agentNames.content +
        '&username=' +
        this.username
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.evaluation_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
